'use client';

import { useMemo } from 'react';
import useDriftAccountStore from 'src/stores/useDriftAccountsStore';
import { COMMON_UI_UTILS } from '@drift/common';

/* Returns max margin ratio and max leverage conversion for the currently selected user account */
const useMaxMarginRatioAndLeverage = (): [number, number] => {
	const customMarginRatio = useDriftAccountStore(
		(s) => s.getCurrentUserAccount()?.client?.getUserAccount()?.maxMarginRatio
	);

	const customMaxLeverage = useMemo(() => {
		return COMMON_UI_UTILS.convertMarginRatioToLeverage(
			customMarginRatio ?? 0,
			2
		);
	}, [customMarginRatio]);

	return [customMarginRatio ?? 0, customMaxLeverage ?? 0];
};

export default useMaxMarginRatioAndLeverage;
